













import {
  defineComponent, computed, reactive, watch, ref,
} from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';
import VueTagsInput from '@johmun/vue-tags-input';

import tagsQuery from '@/gql/tags.gql';

// See: http://www.vue-tags-input.com/#/api/props "Tags"
const CommonTagsMultiSelector = defineComponent({
  setup(props: any, context: any) {
    const tag = ref('');
    const tags = computed(() => props.value.map((t: string) => ({ text: t }))); // convert to lib's format

    const { result: tagsResult } = useQuery(tagsQuery, computed(() => ({
      searchName: `%${tag.value}%`,
    })));
    const searchedTags = useResult(tagsResult, [], (data) => {
      const parsedTags = data.tags.map((t: { name: string }) => ({ text: t.name })); // convert to lib's format
      return parsedTags;
    });

    function onTagsUpdated(newTags: { text: string }[]) {
      context.emit('input', newTags.map((objTag) => objTag.text)); // convert back to our format
    }

    return {
      tag,
      tags,
      onTagsUpdated,
      searchedTags,
    };
  },
  props: {
    value: {
      type: Array,
      default() { return []; },
    },
    label: {
      type: String,
      default() { return 'Tags'; },
    },
  },
  components: {
    VueTagsInput,
  },
});

export default CommonTagsMultiSelector;
